import React from 'react';
import { postCaptureEvent, postCaptureEventWithToken } from 'components/shared/XpressId/services';

export const withHandlersServerLogging = WrappedComponent => {
    const ComponentWithHandlersServerLogging = ({
        onProcessCancelled,
        onProcessError,
        onProcessEvents,
        onProcessCompleted,
        clientId,
        token,
        ...otherProps
    }) => {
        const logEventWrapper = handler => data => {
            const { code, message, type, infoEvent } = data;
            const captureEventData = { code, message, type, infoEvent };
            if (token && clientId) {
                void postCaptureEventWithToken(token, clientId, captureEventData);
            } else {
                void postCaptureEvent(captureEventData);
            }

            return handler?.(data);
        };

        return (
            <WrappedComponent
                {...otherProps}
                onProcessCancelled={logEventWrapper(onProcessCancelled)}
                onProcessError={logEventWrapper(onProcessError)}
                onProcessEvents={logEventWrapper(onProcessEvents)}
                onProcessCompleted={logEventWrapper(onProcessCompleted)}
            />
        );
    };
    ComponentWithHandlersServerLogging.displayName = `WithHandlersServerLogging(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    return ComponentWithHandlersServerLogging;
};
